import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { COMPANY_MANAGED_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import type { JswProjectMenu$key } from '@atlassian/jira-relay/src/__generated__/JswProjectMenu.graphql';
import { JswExpandableProject } from './jsw-expandable-project/JswExpandableProject.tsx';
import { JswNonExpandableProject } from './jsw-non-expandable-project/JswNonExpandableProject.tsx';

type JswProjectMenuProps = {
	projectData: JswProjectMenu$key;
	spotlight?: string;
	menuItemAnchorRef?: React.RefObject<HTMLAnchorElement>;
	menuItemButtonRef?: React.RefObject<HTMLButtonElement>;
};

export const JswProjectMenu = ({
	projectData,
	spotlight,
	menuItemAnchorRef,
	menuItemButtonRef,
}: JswProjectMenuProps) => {
	const project = useFragment<JswProjectMenu$key>(
		graphql`
			fragment JswProjectMenu on JiraProject
			@argumentDefinitions(
				isProjectActionsSyncEnabled: {
					type: "Boolean!"
					provider: "@atlassian/jira-relay-provider/src/project-actions-sync-iv-llc.relayprovider"
				}
			) {
				softwareBoardCount
				projectStyle
				...JswNonExpandableProject
				...JswExpandableProject @skip(if: $isProjectActionsSyncEnabled)
				...JswExpandableProjectNew @include(if: $isProjectActionsSyncEnabled)
			}
		`,
		projectData,
	);

	if (
		project.softwareBoardCount &&
		project.softwareBoardCount > 0 &&
		project.projectStyle === COMPANY_MANAGED_PROJECT
	) {
		return (
			<JswExpandableProject
				projectData={project}
				spotlight={spotlight}
				menuItemButtonRef={menuItemButtonRef}
			/>
		);
	}

	return (
		<JswNonExpandableProject
			projectData={project}
			spotlight={spotlight}
			menuItemAnchorRef={menuItemAnchorRef}
		/>
	);
};
